const PaymentTypeEnum = {
  CASH: 'cod',
  VIVA: 'viva_card_smart_checkout'
}

export default PaymentTypeEnum
